<div class="content {{ size }} {{ inlineLabel ? 'inline' : '' }}">
  @if (label) {
    <label>
      {{ label }}
      @if (isRequired) {
        <strong>*</strong>
      }
    </label>
  }
  <div>
    <div class="input-container" [ngClass]="{ 'input-disabled': isDisabled }">
      <div class="field" [class.error]="error">
        @if (type === 'video') {
          <img src="../../../../assets/images/icons/video-ico.svg" alt="video" />
        }
        @if (type === 'image') {
          <img src="../../../../assets/images/icons/image-ico.svg" alt="image" />
        }
        @if (type !== 'video' && type !== 'image') {
          <img src="../../../../assets/images/icons/file-ico.svg" alt="file" />
        }
        <span [class]="fileName ? 'filled' : ''">
          {{ fileName || 'Select file...' }}
        </span>
      </div>
      <label [for]="'input-' + id">Browse</label>
      <input
        type="file"
        [id]="'input-' + id"
        [accept]="getMimeType()"
        (change)="onFileChange($event.target.files, $event.target.value.length)"
        [disabled]="isDisabled"
        data-cy="file-picker-input"
      />
    </div>
    @if (value) {
      <div class="selected-file-container">
        <img src="../../../../assets/images/icons/link.svg" alt="link" />
        <div class="selected-value" title="{{ value }}">{{ value }}</div>
        @if (!isDisabled) {
          <app-button size="tiny" type="danger" (click)="removeFile()" iconUrl="../../../../assets/images/icons/delete.svg"> Delete </app-button>
        }
      </div>
    }
  </div>
  @if (error) {
    <div class="error-message">{{ error }}</div>
  }
</div>
